import {Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {FieldConfigName} from '../../../models';
import {DmConfirmDialogComponent} from '../../shared/confirm-dialog/confirm-dialog.component';
import {Constants} from '../../common/constants';
import {PhoneInputDialogComponent} from './phone-input-dialog.component';
import {FieldControlMaster} from '../control-master-label-required';
import {SelectInputDialogComponent} from '../select-input';

@Component({
  selector: 'app-phone-input',
  templateUrl: './phone-input.component.html',
  styleUrls: ['./phone-input.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PhoneInputComponent extends FieldControlMaster implements OnInit {
  @Output() phoneInputUpdateControl = new EventEmitter<{ control: FieldConfigName, index: number }>();
  @Output() phoneInputDelete = new EventEmitter<number>();
  dialogComponent = PhoneInputDialogComponent;
  constructor() {
    super();
  }
  ngOnInit(): void {
  }
  onUpdatedControl(object) {
    this.phoneInputUpdateControl.emit(object);
  }
  onDeletedControl(index: number) {
    this.phoneInputDelete.emit(index);
  }
}
